import {
  StreamSkeletonBox,
  StreamSkeletonLeft,
  StreamSkeletonAvatar,
  StreamSkeletonRight,
  StreamSkeletonUsername,
  StreamSkeletonDate,
  StreamSkeletonContent,
} from './styled';

function Skeleton() {
  return (
    <StreamSkeletonBox>
      <StreamSkeletonLeft>
        <StreamSkeletonAvatar />
      </StreamSkeletonLeft>
      <StreamSkeletonRight>
        <StreamSkeletonUsername />
        <StreamSkeletonDate />
        <StreamSkeletonContent />
      </StreamSkeletonRight>
    </StreamSkeletonBox>
  );
}

export default Skeleton;
